import apiCall from "auth/ApiCallInstance";
import { urlBase64ToUint8Array } from "../utils/pushClient";
import { API_BASE_URL } from "configs/AppConfig";

const API = API_BASE_URL;

export async function enablePushForAdmin() {
  try {
    console.log("[push] start");

    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
      console.log("[push] not supported");
      return;
    }

    const reg = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
    await navigator.serviceWorker.ready;

    if (!navigator.serviceWorker.controller) {
      await new Promise((resolve) => {
        navigator.serviceWorker.addEventListener("controllerchange", resolve, { once: true });
      });
    }

    console.log("[push] sw ready + controlling");

    const perm = await Notification.requestPermission();
    console.log("[push] permission:", perm);
    if (perm !== "granted") return;

    const { data } = await apiCall.get(`${API}/push/public-key`);
    console.log("[push] got public key", data?.publicKey?.slice(0, 12) + "...");
    const publicKey = data.publicKey;

    let sub = await reg.pushManager.getSubscription();
    console.log("[push] existing sub?", !!sub);

    if (!sub) {
      try {
        sub = await reg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(publicKey),
        });
        console.log("[push] subscribe OK");
      } catch (e) {
        console.error("[push] subscribe FAIL:", e);
        return;
      }
    }

    // ✅ Convert to clean JSON before sending
    const plainSub = sub.toJSON ? sub.toJSON() : JSON.parse(JSON.stringify(sub));
    console.log("[push] plainSub:", plainSub);

    console.log("[push] posting subscription to server...");
    try {
      const r = await apiCall.post(`${API}/push/subscribe`, plainSub, {
        headers: { "Content-Type": "application/json" },
        skipAuth: true, // if needed
      });
      console.log("[push] server saved:", r?.data);
    } catch (e) {
      console.error("[push] POST /subscribe failed:", e?.response?.data || e);
      return;
    }

    console.log("[push] done ✅");
  } catch (e) {
    console.error("[push] unexpected error:", e);
  }
}
